import { createObservableOperation } from 'owa-observable-operation';
import { getPlacesService } from 'places-service';
import { getDateRangeISOString } from 'hybridspace-common/lib/utils/getDateRangeISOString';

import type { DateRange } from 'owa-datetime-utils';
import type { TraceErrorObject } from 'owa-analytics-types';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import type {
    CollaboratorScheduleWithLocation,
    Collaborator,
} from 'hybridspace-common/lib/serviceTypes';

const dest = createObservableOperation(
    'PLACES_LOAD_SAVED_COLLABORATORS_LOCATIONS',
    (
        dateRange: DateRange
    ): {
        dateRange: DateRange;
    } => ({
        dateRange,
    }),
    ({ dateRange }) => getDateRangeISOString(dateRange),
    ({ dateRange }) => getPlacesService().getCollaboratorsLocations(dateRange),
    () => getModuleContextMailboxInfo()
);
const getCollaboratorsLocationsLastError: (key: string) => TraceErrorObject | undefined =
    dest.getLastError;
const loadCollaboratorsLocations: (dateRange: DateRange) => {
    dateRange: DateRange;
} = dest.start;
const loadCollaboratorsLocationsInProgress: (key: string) => boolean = dest.isInProgress;
const loadCollaboratorsLocationsStarted: (
    actionMessage: {
        dateRange: DateRange;
    },
    promise: Promise<{
        collaboratorScheduleWithLocation: CollaboratorScheduleWithLocation[];
        savedCollaborators: Collaborator[];
        suggestedCollaborators: Collaborator[];
    }>
) => {
    dateRange: DateRange;
} = dest.onStarted;
const loadCollaboratorsLocationsSucceeded: (
    actionMessage: {
        dateRange: DateRange;
    } & {
        result: {
            collaboratorScheduleWithLocation: CollaboratorScheduleWithLocation[];
            savedCollaborators: Collaborator[];
            suggestedCollaborators: Collaborator[];
        };
    }
) => {
    dateRange: DateRange;
} & {
    result: {
        collaboratorScheduleWithLocation: CollaboratorScheduleWithLocation[];
        savedCollaborators: Collaborator[];
        suggestedCollaborators: Collaborator[];
    };
} = dest.onSucceeded;
const loadCollaboratorsLocationsFailed: (
    actionMessage: {
        dateRange: DateRange;
    },
    error?: TraceErrorObject
) => {
    dateRange: DateRange;
} & {
    error?: TraceErrorObject;
} = dest.onFailed;
const loadCollaboratorsLocationsEnded: (actionMessage: { dateRange: DateRange }) => {
    dateRange: DateRange;
} = dest.onEnded;

export {
    getCollaboratorsLocationsLastError,
    loadCollaboratorsLocations,
    loadCollaboratorsLocationsEnded,
    loadCollaboratorsLocationsFailed,
    loadCollaboratorsLocationsStarted,
    loadCollaboratorsLocationsInProgress,
    loadCollaboratorsLocationsSucceeded,
};
